var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.headerContainer},[_vm._l((_vm.block.innerBlocks),function(innerBlock,key){return _c('Block',{key:`headerBlock${key}`,attrs:{"block":innerBlock,"lazy":false}})}),(_vm.emailFormShow)?_c('RetrieveQuoteModal',{on:{"close-modal":_vm.toggleModal}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }